import React, { useEffect, useMemo, useState } from "react";
import { PrimaryButton, Card, SecondaryButton, Loader } from "cdk-radial";
import config from "../config/app.conf.json";
import axios from "axios";

import "./style.css";
import PricePlanList from "./BundlePricePlan";
import { PRICING_ADD_PLAN, PRICING_EDIT_PLAN, PRICING_SHARE_PLAN, RETIRED_PRICING_PLANS, VIEW_BUNDLES } from "./screen";
import withNavigationToBundles from "./withNavigationToBundles";
import PricingBreadcrumbs from "./PricingBreadcrumbs";

function PricingListPlans({
  auth,
  setScreen,
  setSelectedPricingPlan,
  setShowSuccessToast,
  setToastMessage,
  getBundlePricingPlans,
  resetBundlePricingPlans,
  resetBundlePlan,
  setPrevScreenForHistory,
  setPricePlanForHistory,
  resetBundlePlanDetails,
  ApiBundleManagementReducer,
}) {
  const [showingHistoryView, setShowingHistoryView] = useState(false);

  const {
    bundlePricingPlans,
    fetchingBundlePricingPlans,
    errorFetchingBundlePricingPlans,
    errorFetchingBundlePricingPlansMessage,
    selectedBundle
  } = ApiBundleManagementReducer;

  const { accessToken } = auth;

  const breadcrumbs = useMemo(() => {
    return [
      {
        label: "Bundle Management",
        onClick: () => {
          setScreen(VIEW_BUNDLES);
          resetBundlePricingPlans();
        },
      },
      { label: "Bundle Pricing" },
    ];
  }, [setScreen]);

  const handleReloadPricingData = async () => {
    try {
      getBundlePricingPlans({ accessToken, bundleId: selectedBundle?.id });
    } catch (error) {
      console.error("Failed to reload pricing data:", error.message || error);
    }
  };

  useEffect(() => {
    getBundlePricingPlans({ accessToken, bundleId: selectedBundle?.id });
  }, [selectedBundle?.id, accessToken]);

  return (
    <>
      {errorFetchingBundlePricingPlans ? (
        <div className="error-div">Something went wrong, please try again.</div>
      ) : fetchingBundlePricingPlans ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <Loader
            className="pricing-plans-loader"
            data-testid="pricing_plans_loader"
            label="Loading pricing plans..."
            variant="inline"
          />
        </div>
      ) : (
        <Card>
          <div className="create-bundle-card">
            {!showingHistoryView && (
              <>
                <div className="bundle-pricing-title">
                  Pricing - {selectedBundle?.name}
                </div>

                <PricingBreadcrumbs breadcrumbs={breadcrumbs} />

                <div>
                  <div className="bundle-pricing-text">Bundle Pricing</div>
                  <div />
                  <div className="bundle_pricing_description">
                    Bundle pricing is a flat monthly fee per location for unlimited
                    API usage. Public plans are visible to all, while private plans
                    are shared with specific organizations. ISV selections appear in
                    the API Directory, and dealer selections are shown in the Dealer
                    Portal for API buyers.
                  </div>
                </div>
              </>
            )}
            <div>
              <>
                {!bundlePricingPlans || bundlePricingPlans.length === 0 ? (
                  <div className="bundle_pricing_content">
                    You do not have any pricing plans.
                  </div>
                ) : (
                  <div style={{ marginBottom: "24px" }}>
                    <PricePlanList
                      auth={auth}
                      pricePlans={bundlePricingPlans}
                      selectedBundle={selectedBundle}
                      onReloadData={handleReloadPricingData}
                      onHistoryViewChange={setShowingHistoryView}
                      setShowSuccessToast={setShowSuccessToast}
                      setSelectedPricingPlan={setSelectedPricingPlan}
                      setPrevScreenForHistory={setPrevScreenForHistory}
                      setPricePlanForHistory={setPricePlanForHistory}
                      setScreen={setScreen}
                      setToastMessage={setToastMessage}
                      onSharePlan={(plan) => {
                        setSelectedPricingPlan(plan);
                        setScreen(PRICING_SHARE_PLAN);
                      }}
                      onEditPlan={(planData) => {
                        setSelectedPricingPlan(planData);
                        setScreen(PRICING_EDIT_PLAN);
                      }}
                    />
                  </div>
                )}
                {!showingHistoryView && (
                  <>
                    <PrimaryButton
                      dataTestId="save-bundle"
                      text="Add Plan"
                      onClick={() => {
                        setSelectedPricingPlan(null);
                        if (resetBundlePlanDetails) resetBundlePlanDetails();
                        setScreen(PRICING_ADD_PLAN);
                      }}
                      style={{ marginRight: "8px" }}
                    />
                    <SecondaryButton
                      dataTestId="view-retired-plans"
                      text="View Retired Plans"
                      onClick={() => {
                        setScreen(RETIRED_PRICING_PLANS);
                      }}
                    />
                  </>
                )}
              </>
            </div>
          </div>
        </Card>
      )}
    </>
  );
}

export default withNavigationToBundles(PricingListPlans);
